

import http from "@/http/service"

export default function ServicoByid(idParceiro=0){
    return http.get(`/admin/servicos/${idParceiro}`)
}